import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal"]

  saveBeforeInstallPromptEvent(event) {
    this.beforeInstallPromptEvent = event
  }

  install(event) {
    event.preventDefault()

    if (this.beforeInstallPromptEvent) {
      this.beforeInstallPromptEvent.prompt()
    } else {
      new Modal(this.modalTarget).show()
    }
  }
}
